import { useState, useCallback } from 'react';
import { apiClient } from '../utils/apiClient';
import { API_CONFIG } from '../config/apiConfig';

interface RadSite {
  organizationId: string;
  organizationName: string;
}

interface ApiResponse {
  success: boolean;
  data?: RadSite[];
  error?: string;
}

export const useRadSites = () => {
  const [data, setData] = useState<RadSite[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchRadSites = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await apiClient.get<ApiResponse>(API_CONFIG.ENDPOINTS.GET_RAD_SITES);

      
      // Handle nested response structure like other APIs
      let responseData = response.data;
      if (response.data.data && typeof response.data.data === 'object' && 'statusCode' in response.data.data) {
        responseData = JSON.parse((response.data.data as any).body);
      }
      
      if (responseData.success && Array.isArray(responseData.data)) {
        const sites = responseData.data.map((item: any) => ({
          organizationId: item.organizationId || item.ORGANIZATIONID || item.organization_id || '',
          organizationName: item.organizationName || item.ORGANIZATIONNAME || item.organization_name || ''
        })).filter(site => site.organizationName);
        console.log('Extracted sites:', sites);
        setData(sites);
      } else {
        throw new Error(responseData.error || 'Failed to fetch RAD sites');
      }
    } catch (err: any) {
      console.error('RAD Sites Error:', err);
      setError(err.message || 'Error fetching RAD sites');
      setData([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    data,
    isLoading,
    error,
    fetchRadSites
  };
};